import React, { useRef } from 'react';
var VeltNotificationsPanelContent = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content", { ref: ref }, children));
};
export default VeltNotificationsPanelContent;
